import ChallangeUserMail from './ChallangeUserMail';
export default ChallangeUserMail;
